import React from 'react';
import { useSelector } from 'react-redux';
import { getSurveyResponses } from '../../../surveySlice';

import './QuestionSectionHeader.scss';

const QuestionSectionHeader = ({ sectionId }) => {
  const surveyResponses = useSelector(getSurveyResponses);

  const section =
    surveyResponses && surveyResponses.sections.find((s) => s.id === sectionId);

  return (
    surveyResponses && (
      <div className="question-section-header">
        <div className="section-title">{section.title}</div>
        <p className="section-description">{section.description}</p>
      </div>
    )
  );
};

export default QuestionSectionHeader;
